<div class="notify-content">
    <h1>Jessica Duarte</h1>
    <h6>(Microsoft Advocate)</h6>
</div>